import React from 'react'
import style from './about.module.css'
import myv from '../../images/myv.jpg'
import creative from '../../images/creative.jpg'
import compromise from '../../images/compromise.jpg'
import experience from '../../images/experience.jpg'
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

const About = ({visibleElements, elementsRef}) => {
    return (
        <section id={'about'} className={style['about']}
            ref={(el) => (elementsRef.current[2] = el)}>

            <div className={`${style['about__container']}
            ${style['about__container--has-background-color']}`}>

                <h2 className={`${style['about__title']}
                ${visibleElements.includes(elementsRef.current[3]) ?
                        style['about__title--transition'] : ''}`}>
                    Sobre Nosotros.
                </h2>

                <section className={style['about__section']} ref={(el) => (elementsRef.current[3] = el)}>

                    <h3 className={`${style['about__subtitle']}
                    ${visibleElements.includes(elementsRef.current[3]) ?
                            style['about__subtitle--transition'] : ''}`}>
                        Misión:
                    </h3>

                    <p className={`${style['about__description']} 
                    ${visibleElements.includes(elementsRef.current[3]) ?
                            style['about__description--transition'] : ''}`}>
                        Potenciar la presencia digital de nuestros clientes
                        a través de soluciones personalizadas y crear
                        videojuegos indie innovadores.
                    </p>

                </section>

                <div className={style['about__section']} ref={(el) => (elementsRef.current[4] = el)}>

                    <img src={myv} alt='Imagen de Misión y Visión'
                        className={`lazyload ${style['about__image']}
                    ${visibleElements.includes(elementsRef.current[4]) ?
                                style['about__image--transition-one'] : ''}`} />

                </div>

                <section className={style['about__section']} ref={(el) => (elementsRef.current[5] = el)}>

                    <h2 className={`${style['about__subtitle']}
                    ${visibleElements.includes(elementsRef.current[5]) ?
                            style['about__subtitle--transition'] : ''}`}>
                        Visión:
                    </h2>

                    <p className={`${style['about__description']} 
                    ${visibleElements.includes(elementsRef.current[5]) ?
                            style['about__description--transition'] : ''}`}>
                        Seguir creciendo en el desarrollo de videojuegos indie y
                        ofrecer los mejores sitios web modernos y personalizados.
                    </p>

                </section>

            </div>

            <div className={`${style['about__container']}
            ${style['about__container--has-background-degraded']}`}>

                <div className={style['about__section']} ref={(el) => (elementsRef.current[6] = el)}>

                    <img src={creative} alt='Imagen de innovación y creatividad'
                        className={`lazyload ${style['about__image']}
                    ${visibleElements.includes(elementsRef.current[6]) ?
                                style['about__image--transition-two'] : ''}`} />

                    <h2 className={`${style['about__subtitle']}
                    ${visibleElements.includes(elementsRef.current[6]) ?
                            style['about__subtitle--transition'] : ''}`}>
                        Innovación y Creatividad:
                    </h2>

                    <p className={`${style['about__description']} 
                    ${visibleElements.includes(elementsRef.current[6]) ?
                            style['about__description--transition'] : ''}`}>
                        Nuestro equipo combina la pasión por los videojuegos
                        con el desarrollo web para crear experiencias digitales
                        impactantes.
                    </p>

                </div>

                <div className={style['about__section']} ref={(el) => (elementsRef.current[7] = el)}>

                    <img src={compromise} alt='Imagen de compromiso con el desarrollo web'
                        className={`lazyload ${style['about__image']}
                    ${visibleElements.includes(elementsRef.current[7]) ?
                                style['about__image--transition-two'] : ''}`} />

                    <h2 className={`${style['about__subtitle']}
                    ${visibleElements.includes(elementsRef.current[7]) ?
                            style['about__subtitle--transition'] : ''}`}>
                        Compromiso con el Desarrollo Web:
                    </h2>

                    <p className={`${style['about__description']} 
                    ${visibleElements.includes(elementsRef.current[7]) ?
                            style['about__description--transition'] : ''}`}>
                        Estamos entusiasmados por aplicar nuestra pasión y creatividad
                        para desarrollar sitios web modernos para diversas empresas.
                    </p>

                </div>

                <div className={style['about__section']} ref={(el) => (elementsRef.current[8] = el)}>

                    <img src={experience} alt='Imagen de experiencia en el videojuego indie'
                        className={`lazyload ${style['about__image']}
                    ${visibleElements.includes(elementsRef.current[8]) ?
                                style['about__image--transition-two'] : ''}`} />

                    <h2 className={`${style['about__subtitle']}
                    ${visibleElements.includes(elementsRef.current[8]) ?
                            style['about__subtitle--transition'] : ''}`}>
                        Experiencia en el Videojuego Indie:
                    </h2>

                    <p className={`${style['about__description']} 
                    ${visibleElements.includes(elementsRef.current[8]) ?
                            style['about__description--transition'] : ''}`}>
                        Nuestro primer juego en la Play Store nos ha brindado
                        valiosos conocimientos, y estamos emocionados por crear más.
                    </p>

                </div>

            </div>

        </section>
    );
};

export default About;
